import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { OrderformFascade } from '../../fascades/orderform.fascade';
import { distinctUntilChanged, map, tap } from 'rxjs/operators';
import { UntypedFormControl } from '@angular/forms';
import { isPageBuilderDesignMode } from '../../misc/pagebuilder';
import { firstValueFrom, ReplaySubject } from 'rxjs';
import { OrderformCurrencyOption } from '@orderform/widgets';

@Component({
  selector: 'orderform-currency-selector',
  templateUrl: './currency-selector.component.html',
  styleUrls: ['./currency-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrencySelectorComponent implements OnDestroy {
  public isDesignMode = isPageBuilderDesignMode();
  public form = new UntypedFormControl();

  selectedCurrency$: ReplaySubject<OrderformCurrencyOption> =
    new ReplaySubject<OrderformCurrencyOption>(1);

  public currencyList$ = this._orderformFascade.globalSettings$.pipe(
    map((setting) => setting.currency_options)
  );

  private _subscriptionValueChange = this._orderformFascade.globalSettings$
    .pipe(
      tap((settings) => {
        const selectedCurrency = settings.currency_options.find(
          (currency) => currency.code === settings.currency_code
        );

        if (selectedCurrency) {
          this.selectedCurrency$.next(selectedCurrency);
        }
      }),
      map((setting) => setting.currency_code),
      distinctUntilChanged()
    )
    .subscribe((code) => {
      this.form.patchValue(code, {
        emitModelToViewChange: true,
        emitEvent: true,
      });
    });

  private _subscriptionValueUpdate = this.form.valueChanges
    .pipe(distinctUntilChanged())
    .subscribe((currencyCode) => {
      this._orderformFascade.setOrderStore({
        currency: currencyCode,
      });
      firstValueFrom(this._orderformFascade.update$());
    });

  constructor(private _orderformFascade: OrderformFascade) {}

  ngOnDestroy() {
    this._subscriptionValueChange.unsubscribe();
    this._subscriptionValueUpdate.unsubscribe();
  }
}
